module.exports = __webpack_public_path__ + "static/media/it-support-img-4.bb5a0e33.png";